import createPredicateIndexFinder from './_createPredicateIndexFinder.js';

// Returns the first index on an array-like that passes a truth test.
export default createPredicateIndexFinder(1);



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/findIndex.js
// module id = 372
// module chunks = 1